import { HttpClient } from '@angular/common/http';
import { afterNextRender, isDevMode } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { BehaviorSubject, catchError, firstValueFrom, from, lastValueFrom, Observable, of, Subject, take } from 'rxjs';
import { StorageUtil } from './storage.util';

type Translate = { [key: string]: Translate | string | {}; }

class CustomTranslateLoader implements TranslateLoader {
  private loading = new Subject<any>();
  constructor(private http: HttpClient) {
    afterNextRender(() => {
      firstValueFrom(this.http.get('/assets/translations/vo.json')).then(_ => this.loading.next(_));
    })
  }
  getTranslation(lang: string): Observable<any> {
    return this.loading.asObservable()

  }
}
class TranslateLocalLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}
  private _removeNestedNullUndefined(_translations: { [key: string]: any }) {
    let translations = structuredClone(_translations);
    for (const key in translations) {
      if (translations[key] === null || translations[key] === undefined) {
        delete translations[key];
      } else if (typeof translations[key] === 'object') {
        translations[key] = this._removeNestedNullUndefined(translations[key]);
      }
    }
    return translations;
  }
  private _isObject(item: any): item is Object {
    return (item && typeof item === 'object' && !Array.isArray(item));
  }
  private _mergeDeep(target: Translate, ...sources: Translate[]): Translate {
    if (!sources.length) return target;
    const source = sources.shift();

    if (this._isObject(target) && this._isObject(source)) {
      for (const key in source) {
        if (this._isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          this._mergeDeep(target[key] as Translate, source[key] as Translate);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }

    return this._mergeDeep(target, ...sources);
  }

  getTranslation(lang: string): Observable<any> {
    return from(new Promise(async (resolve, reject) => {
      let _default = await lastValueFrom(this.http.get('/assets/translations/vo.json').pipe(take(1), catchError(() => (of({})))));
      let translations = this._removeNestedNullUndefined(this._spreadAsObject(StorageUtil.get<{ [key: string]: string }>('translations') ?? {}));
      let merged = this._mergeDeep({}, _default as Translate, translations);
      StorageUtil.set<Translate>('translations', merged)
      resolve(merged);
    }))
  }
  private _spreadAsObject(arg0: Translate): Translate {
    let newObj: Translate = {}
    Object
      .entries(arg0)
      .forEach(([key, value]) => {
        let objPos: string | Translate = newObj;
        key
          .split('.')
          .forEach((subkey, i, arr) => {
            if (objPos != null && typeof objPos != 'string') {
              if (objPos[subkey] == null && i < arr.length - 1) {
                objPos[subkey] = {}
              } else if (i == arr.length - 1 && typeof objPos == 'object') {
                objPos[subkey] = value;
              }
              objPos = objPos[subkey];
            }
          })
      })
    return newObj;
  }
}
export class CustomMissingTranslationHandler {
  handle(params: any) {
    if (isDevMode()) {
      console.warn('Missing Translation for:', params.key);
    }
    return '';
  }
}
export function TranslationHttpLoader(http: HttpClient) {
  let loader: TranslateLoader;

  // if (isDevMode()) {
  //   loader = new CustomTranslateLoader(http);
  // } else {
  loader = new TranslateLocalLoader(http);
  // }
  return loader;
}
